<template>
  <div>
    <h4 v-if="title">{{ title }}</h4>
    <v-layout>
      <v-flex xs6>
        <e-color-picker
          :label="buttonTitle"
          :value="color"
          @colorChange="onColorChange"
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import EColorPicker from '@/components/shared/EColorPicker'
  import { colorValidator } from './../styleForms/utils'
  import { clone, isEmpty } from 'ramda'
  import { generateDefaultColor, getColorsParams } from './../styleForms/utils'

  export default {
    name: 'ColorSettings',
    components: {
      EColorPicker
    },
    props: {
      title: {
        type: String,
        default: ''
      },
      buttonTitle: {
        type: String,
        default: 'color'
      },
      color: {
        type: Object,
        validator: colorValidator,
        default: generateDefaultColor
      }
    },
    methods: {
      onColorChange (color) {
        this.$emit('update:color', getColorsParams(color))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/GeneralSettings/StylesSettings/styleSettingsFormComponents/ColorSettings.vue